import { all, call, fork, takeEvery, takeLatest } from 'redux-saga/effects';

import * as constants from './meetings-simple.constants';
import * as types from './meetings-simple.types';
import * as services from './meetings-simple.saga-services';

function* invokeCreateMeetingSimple(action: types.ICreateMeetingSimple) {
  yield call(services.createMeetingSimple, action.payload);
}

function* invokeUpdateMeetingSimple(action: types.IUpdateMeetingSimple) {
  yield call(services.updateMeetingSimple, action.payload.id, action.payload.data);
}

function* invokeUpdateMeetingParticipants(action: types.IUpdateMeetingParticipants) {
  yield call(services.updateMeetingParticipants, action.payload.id, action.payload.data);
}

function* invokeMeetingSimpleUpdateFolder(action: types.IUpdateMeetingSimpleFolder) {
  yield call(services.updateFolder, action.payload.id, action.payload.data);
}

function* invokeDeleteMeetingSimple(action: types.IDeleteMeetingSimple) {
  yield call(services.deleteMeetingSimple, action.payload);
}

function* invokeStartMeetingSimpleSession(action: types.IStartMeetingSimpleSession) {
  yield call(services.startMeetingSimpleSession, action.payload.meetingId);
}

function* invokeFinishMeetingSession(action: types.IFinishMeetingSimpleSession) {
  yield call(
    services.finishMeetingSimpleSession,
    action.payload.meetingId,
    action.payload.sessionId,
    action.payload.cancelled,
  );
}

function* invokeFinishMeetingSessionSocket(action: types.IFinishMeetingSimpleSessionSocket) {
  yield call(services.finishMeetingSimpleSessionSocket, action.payload.meetingId, action.payload.sessionId);
}

function* invokeSaveMeetingSimpleSocket(action: types.ISaveMeetingSimpleSocket) {
  yield call(services.saveMeetingSimpleSocket, action.payload);
}
function* invokeDeleteMeetingSimpleSocket(action: types.IDeleteMeetingSimpleSocket) {
  yield call(services.deleteMeetingSimpleSocket, action.payload);
}

function* invokeStartMeetingSessionSocket(action: types.IStartMeetingSessionSocket) {
  yield call(services.startMeetingSessionSocket, action.payload);
}

function* invokeJoinMeeting(action: types.IJoinMeeting) {
  yield call(services.joinMeeting, action.payload.session);
}

function* invokeFetchMeetingSimple() {
  yield call(services.setupMeetingsSimple);
}

function* invokeJoinMeetingSocket(action: types.IJoinMeetingSocket) {
  yield call(
    services.joinMeetingSocket,
    action.payload.actionUserId,
    action.payload.sessionId,
    action.payload.startedBy,
  );
}

function* invokeSendMessageToMeetingMembers(action: types.ISendMessageToMeetingMembers) {
  yield call(
    services.sendMessageToMeetingMembers,
    action.payload.sender_id,
    action.payload.receiver_ids,
    action.payload.meeting_id,
    action.payload.message,
  );
}

function* invokeFetchLiveSessions() {
  yield call(services.fetchLiveSessions);
}

export function* watchMeetingsSimplePurePageSaga() {
  yield takeLatest(constants.CREATE_MEETING_SIMPLE, invokeCreateMeetingSimple);
  yield takeLatest(constants.FETCH_MEETINGS_SIMPLE, invokeFetchMeetingSimple);
  yield takeLatest(constants.UPDATE_MEETING_SIMPLE, invokeUpdateMeetingSimple);
  yield takeLatest(constants.UPDATE_MEETING_PARTICIPANTS, invokeUpdateMeetingParticipants);
  yield takeLatest(constants.DELETE_MEETING_SIMPLE, invokeDeleteMeetingSimple);
  yield takeLatest(constants.START_MEETING_SIMPLE_SESSION, invokeStartMeetingSimpleSession);
  yield takeLatest(constants.JOIN_MEETING, invokeJoinMeeting);
  yield takeLatest(constants.UPDATE_MEETING_SIMPLE_FOLDER, invokeMeetingSimpleUpdateFolder);
  yield takeLatest(constants.SEND_MESSAGE_TO_MEETING_MEMBERS, invokeSendMessageToMeetingMembers);
  yield takeEvery(constants.SAVE_MEETING_SIMPLE_SOCKET, invokeSaveMeetingSimpleSocket);
  yield takeEvery(constants.DELETE_MEETING_SIMPLE_SOCKET, invokeDeleteMeetingSimpleSocket);
  yield takeEvery(constants.START_MEETING_SESSION_SOCKET, invokeStartMeetingSessionSocket);
  yield takeEvery(constants.FINISH_MEETING_SIMPLE_SESSION, invokeFinishMeetingSession);
  yield takeEvery(constants.FINISH_MEETING_SIMPLE_SESSION_SOCKET, invokeFinishMeetingSessionSocket);
  yield takeEvery(constants.JOIN_MEETING_SOCKET, invokeJoinMeetingSocket);
  yield takeEvery(constants.FETCH_LIVE_MEETINGS, invokeFetchLiveSessions);
}

export function* watchMeetingsSimplePageStorageSaga() {
  yield all([watchMeetingsSimplePurePageSaga].map(fork));
}
